import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../helpers'
import {useAuth} from '../../../../app/modules/auth'

const InviteUsers: FC<{onClose: () => void; refIncomePercent?: number}> = ({
  onClose,
  refIncomePercent = 10,
}) => {
  const {currentUser} = useAuth()
  const intl = useIntl()

  const copyToClipboard = () => {
    const link = `https://energyblockchain.co/auth/registration?ref=${currentUser?.id}`
    navigator.clipboard
      .writeText(link)
      .then(() => {
        alert(intl.formatMessage({id: 'INVITE_MODAL.COPIED'}))
      })
      .catch(() => {
        alert(intl.formatMessage({id: 'INVITE_MODAL.COPY_ERROR'}))
      })
  }

  return (
    <div className='modal fade show d-block' id='kt_modal_invite_friends' aria-hidden='true'>
      <div className='modal-dialog mw-650px'>
        <div className='modal-content'>
          <div className='modal-header pb-0 border-0 justify-content-end'>
            <div
              onClick={onClose}
              className='btn btn-sm btn-icon btn-active-color-primary'
              data-bs-dismiss='modal'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>

          <div className='modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15'>
            <div className='text-center mb-13'>
              <h1 className='mb-3'>{intl.formatMessage({id: 'INVITE_MODAL.TITLE'})}</h1>
              <div className='text-muted fw-bold fs-5'>
                {intl.formatMessage({id: 'INVITE_MODAL.DESC'}, {percent: refIncomePercent})}
              </div>
            </div>

            <div className='btn btn-light-primary fw-bolder w-100 mb-8'>
              {intl.formatMessage({id: 'INVITE_MODAL.LINK_LABEL'})}
            </div>

            <div className='separator d-flex flex-center mb-8'></div>

            <code
              className='d-block text-center cursor-pointer text-primary'
              onClick={copyToClipboard}
              style={{cursor: 'pointer'}}
            >
              https://bitsobit.academy/auth/registration?ref={currentUser?.id}
            </code>

            <div className='d-flex flex-stack mt-10'>
              <div className='fw-bold w-100 d-flex justify-content-between'>
                <div className='fs-7'>
                  {intl.formatMessage({id: 'INVITE_MODAL.REFERRALS_COUNT'}, {
                    count: currentUser?.ref_num ?? 0,
                  })}
                </div>
                <div className='fs-7'>
                  {intl.formatMessage({id: 'INVITE_MODAL.TOTAL_INCOME'}, {
                    income: currentUser?.ref_income ?? 0,
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {InviteUsers}
